import { useSnackbar } from 'notistack'
import React, { FC, useState } from 'react'
import { CostumerPropsType, FloorMaterialPropsType, MaterialType } from '../../../api/appAPI'
import { EnqueueSnackbarType, showMessage } from '../../../components/common/Helpers'
import FloorMaterialUIBox from './FloorMaterialUIBox'
import { AvailableMaterialsForFM } from '../../../redux/itemReducer'

interface IProps {
    materials: AvailableMaterialsForFM

    addFloorMaterial(fmProps: FloorMaterialPropsType, enqueueSnackbar: EnqueueSnackbarType): void
}

const DefineFloorMaterial: FC<IProps> = (props) => {
    const [name, setName] = useState('')
    const [sku, setSku] = useState('')
    const [materialId, setMaterialId] = useState(0)
    const [dealerId, setDealerId] = useState('0')
    const [pictureUrl, setPictureUrl] = useState('')
    const [pdfUrl, setPdfUrl] = useState('')
    const [shortDescription, setShortDescription] = useState('')
    const [longDescription, setLongDescription] = useState('')
    const [floorSetupCharge, setFloorSetupCharge] = useState('0')
    const [floorPricePerSqFt, setFloorPricePerSqFt] = useState('0')
    const [curbSetupCharge, setCurbSetupCharge] = useState('0')
    const [curbPricePerSqFt, setCurbPricePerSqFt] = useState('0')
    const [curbLinearPricePerFt, setCurbLinearPricePerFt] = useState('0')

    console.log(materialId);


    const { enqueueSnackbar } = useSnackbar()

    const handleNameChange = (event: React.ChangeEvent<{ value: string }>) => {
        setName(event.target.value.replace(/['"]/, ''))
    }
    const handleSkuChange = (event: React.ChangeEvent<{ value: string }>) => {
        setSku(event.target.value.replace(/['"]/, ''))
    }
    const handlePictureUrlChange = (event: React.ChangeEvent<{ value: string }>) => {
        setPictureUrl(event.target.value.replace(/['"]/, ''))
    }
    const handlePdfUrlChange = (event: React.ChangeEvent<{ value: string }>) => {
        setPdfUrl(event.target.value.replace(/['"]/, ''))
    }
    const handleShortDescriptionChange = (event: React.ChangeEvent<{ value: string }>) => {
        setShortDescription(event.target.value.replace(/['"]/, ''))
    }
    const handleLongDescriptionChange = (event: React.ChangeEvent<{ value: string }>) => {
        setLongDescription(event.target.value.replace(/['"]/, ''))
    }
    const handleFloorSetupChargeChange = (event: React.ChangeEvent<{ value: string }>) => {
        setFloorSetupCharge(event.target.value.replace(/['"]/, ''))
    }
    const handleFloorPricePerSqFtChange = (event: React.ChangeEvent<{ value: string }>) => {
        setFloorPricePerSqFt(event.target.value.replace(/['"]/, ''))
    }
    const handleCurbSetupChargeChange = (event: React.ChangeEvent<{ value: string }>) => {
        setCurbSetupCharge(event.target.value.replace(/['"]/, ''))
    }
    const handleCurbPricePerSqFtChange = (event: React.ChangeEvent<{ value: string }>) => {
        setCurbPricePerSqFt(event.target.value.replace(/['"]/, ''))
    }
    const handleCurbLinearPricePerFtChange = (event: React.ChangeEvent<{ value: string }>) => {
        setCurbLinearPricePerFt(event.target.value.replace(/['"]/, ''))
    }


    const handleCreateClick = () => {
        if (name === '') {
            showMessage(enqueueSnackbar, "Enter name")
            return
        }

        if (sku === '') {
            showMessage(enqueueSnackbar, "Enter sku")
            return
        }


        const fmProps = {
            name, sku, materialId,
            dealerId, pictureUrl, pdfUrl, shortDescription, longDescription,
            floorSetupCharge: parseFloat(floorSetupCharge),
            floorPricePerSqFt: parseFloat(floorPricePerSqFt),
            curbSetupCharge: parseFloat(curbSetupCharge),
            curbPricePerSqFt: parseFloat(curbPricePerSqFt),
            curbLinearPricePerFt: parseFloat(curbLinearPricePerFt)
        } as FloorMaterialPropsType

        props.addFloorMaterial(fmProps, enqueueSnackbar)

        // setFirstName('')
        // setLastName('')
        // setEmail('')
        // setPhone('')
        // setZip('')
        // setAddress1('')
        // setAddress2('')
        // setCity('')
        // setProvince('')
    }

    return (
        <FloorMaterialUIBox
            materials={props.materials}

            title='New Floor Material'

            name={{
                value: name,
                onChange: handleNameChange
            }}
            sku={{
                value: sku,
                onChange: handleSkuChange
            }}
            materialId={{
                value: materialId,
                onChange: setMaterialId
            }}
            floorSetupCharge={{
                value: floorSetupCharge,
                onChange: handleFloorSetupChargeChange
            }}
            floorPricePerSqFt={{
                value: floorPricePerSqFt,
                onChange: handleFloorPricePerSqFtChange
            }}
            curbSetupCharge={{
                value: curbSetupCharge,
                onChange: handleCurbSetupChargeChange
            }}
            curbPricePerSqFt={{
                value: curbPricePerSqFt,
                onChange: handleCurbPricePerSqFtChange
            }}
            curbLinearPricePerFt={{
                value: curbLinearPricePerFt,
                onChange: handleCurbLinearPricePerFtChange
            }}
            shortDescription={{
                value: shortDescription,
                onChange: handleShortDescriptionChange
            }}
            longDescription={{
                value: longDescription,
                onChange: handleLongDescriptionChange
            }}
            pictureUrl={{
                value: pictureUrl,
                onChange: handlePictureUrlChange
            }}
            pdfUrl={{
                value: pdfUrl,
                onChange: handlePdfUrlChange
            }}

            button={{
                text: 'Create',
                onClick: handleCreateClick
            }}

        // editable
        />
    )
}

export default DefineFloorMaterial